import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { catchError, Observable, of, share, throwError } from 'rxjs';
import { environment } from '#environments';
import { Dtos } from '#models';
import { cache } from '#core';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private http = inject(HttpClient);

  @cache()
  public getCurrentUser() {
    return this.http.get<Dtos.LoggedUser>(`${environment.apiUrl}/user/current`).pipe(
      share(),
      catchError(err => {
        if (err instanceof HttpErrorResponse && err.status === 400) {
          return of(null);
        }
        return throwError(() => err);
      })
    );
  }

  public searchParticipants(query: string, organizationId: number): Observable<Dtos.User[]> {
    return this.http.post<Dtos.User[]>(`${environment.apiUrl}/user/searchParticipants`, {
      query,
      limitResults: 20,
      organizationId,
    });
  }

  searchUser(query: string): Observable<Dtos.User[]> {
    return this.http.get<Dtos.User[]>(`${environment.apiUrl}/user/search/${query}/`);
  }

  public autocompleteUsersByBU(buId: number, query: string): Observable<Dtos.User[]> {
    return this.http.get<Dtos.User[]>(`${environment.apiUrl}/user/autocompleteUsersByBU/${buId}/${query}/`);
  }

  public getUsersByOrg(orgId: number): Observable<Dtos.User[]> {
    return this.http.get<Dtos.User[]>(`${environment.apiUrl}/user/getByOrganization/${orgId}`);
  }

  public acceptDisclaimer(userId: number): Observable<Dtos.User> {
    return this.http.put<Dtos.User>(`${environment.apiUrl}/user/acceptDisclaimer/${userId}`, null);
  }

  public sendAccessRequest(email: string, buId: number): Observable<Dtos.User> {
    return this.http.get<Dtos.User>(`${environment.apiUrl}/user/requestAccess/${email}/${buId}`);
  }

  public delete(id: number): Observable<void> {
    return this.http.put<void>(`${environment.apiUrl}/user/delete/${id}`, null);
  }
  public importSharedUser(businessUnitId: number, sharedUserEmail: string): Observable<Dtos.LoggedUser> {
    return this.http.post<Dtos.LoggedUser>(`${environment.apiUrl}/user/getSharedUser`, {
      SharedUserEmail: sharedUserEmail,
      BusinessUnitID: businessUnitId,
    });
  }

  savePreferences({ language }: { language: Dtos.Language }) {
    return this.http.put(`${environment.apiUrl}/user/preferences`, {
      language,
    });
  }
}
